<template>
  <!-- <qx-card-form title="结算信息"> -->
  <section>
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <div slot="recive" slot-scope="prop">
        <div
          v-show="
            prop.form.balanceType === '1' || prop.form.balanceType === '2'
          "
        >
          <el-input
            class="inputBox"
            v-model="otherFormData.reciveTime"
            placeholder="请输入"
          >
            <span slot="suffix" class="inputSlotText">天</span>
          </el-input>
        </div>
        <div v-show="prop.form.balanceType === '3'">
          <el-input
            class="appendInputBox"
            v-model="otherFormData.reciveMonth"
            placeholder="请输入"
          >
            <span slot="suffix"
              >个月后
              <el-select
                class="inputAppendSelect"
                v-model="otherFormData.reciveTimeDay"
                :clear="true"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in 31"
                  :key="item"
                  :label="item + '号'"
                  :value="item"
                />
              </el-select>
            </span>
          </el-input>
        </div>
      </div>
      <div slot="collection" slot-scope="prop">
        <div v-show="prop.form.balanceType === '2'">
          <el-input
            class="inputBox"
            v-model="otherFormData.collectionTime"
            placeholder="请输入"
          >
            <span slot="suffix" class="inputSlotText">天</span>
          </el-input>
        </div>
        <div v-show="prop.form.balanceType === '3'">
          <el-input
            class="appendInputBox"
            v-model="otherFormData.collectionMonth"
            placeholder="请输入"
          >
            <span slot="suffix"
              >个月后
              <el-select
                class="inputAppendSelect"
                v-model="otherFormData.collectionTimeDay"
                :clear="true"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in 31"
                  :key="item"
                  :label="item + '号'"
                  :value="item"
                />
              </el-select>
            </span>
          </el-input>
        </div>
      </div>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </section>
  <!-- </qx-card-form> -->
</template>

<script>
export default {
  props: {
    balanceTypeOptions: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      otherFormData: {
        reciveTime: '', // 回单期限天数
        reciveMonth: '', // 回单期限第几个月
        reciveTimeDay: '', // 回单期限第几号
        collectionTime: '', // 收款期限天数
        collectionMonth: '', // 收款期限第几个月
        collectionTimeDay: '', // 收款期限第几号
      },
      baseForm: {
        balanceTypeOptions: [],
        inline: true,
        form: [
          {
            label: '结算方式',
            value: 'balanceType',
            type: 'select',
            width: '240px',
            default: '-1',
            onChange: () => {
              this.handleLabelTypeChange();
            },
          },
          {
            label: '回单期限',
            value: 'recive',
            slot: true,
          },
          {
            label: '收款期限',
            value: 'collection',
            slot: true,
            hide: true,
          },
        ],
        rules: {
          balanceType: [ // 结算方式
            { required: true, message: '请选择结算方式', trigger: 'blur' },
          ],
          // recive: [ // 回单期限
          //   { validator: this.checkRecive, trigger: 'blur' },
          // ],
          // collection: [ // 收款期限
          //   { validator: this.checkCollection, trigger: 'blur' },
          // ],
        },
      },
    };
  },
  watch: {
    balanceTypeOptions (newVal) {
      this.baseForm.balanceTypeOptions = newVal;
    },
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setData (data) {
      data.line.balanceType = data.line.payWay;
      this.init(data.line);
    },
    setList (options) {
      this.baseForm.balanceTypeOptions = options;
      this.$refs.baseForm.setVal('balanceType', options[0].value);
    },

    /**
     * @param {Array} rule 规则
     * @param {String} value 当前值
     * @param {Function} call 结果执行
     * @returns {void}
     * @description 验证回单期限
     */
    checkRecive (rule, value, call) {
      const balanceType = this.$refs.baseForm.getVal('balanceType');
      if ((balanceType === '1' || balanceType === '2') && !this.otherFormData.reciveTime) {
        call('请输入回单期限天数');
      } else if (balanceType === '3' && (!this.otherFormData.reciveMonth || !this.otherFormData.reciveTimeDay)) {
        call('请输入回单期限天数');
      } else {
        call();
      }
    },

    /**
     * @param {Array} rule 规则
     * @param {String} value 当前值
     * @param {Function} call 结果执行
     * @returns {void}
     * @description 验证收款期限
     */
    checkCollection (rule, value, call) {
      const balanceType = this.$refs.baseForm.getVal('balanceType');
      if (balanceType === '2' && !this.otherFormData.collectionTime) {
        call('请输入收款期限天数');
      } else if (balanceType === '3' && (!this.otherFormData.collectionMonth || !this.otherFormData.collectionTimeDay)) {
        call('请输入收款期限天数');
      } else {
        call();
      }
    },
    handleLabelTypeChange () {
      const balanceType = this.$refs.baseForm.getVal('balanceType');
      let isNotAuto = balanceType === '1';
      const tar = ['collection'];
      this.baseForm.form.forEach((item) => {
        if (tar.indexOf(item.value) !== -1) {
          item.hide = isNotAuto;
        }
      });
    },
    async cacheData () {
      let res = await this.$refs.baseForm.getVal();
      res = {
        balanceType: res.balanceType,
        payWay: res.balanceType,
        ...this.otherFormData,
      };
      return res;
    },

    async sub () {
      let formData = await this.$refs.baseForm.sub();
      if (formData) {
        let customerInfo = {};
        formData = {
          balanceType: formData.balanceType,
          payWay: formData.balanceType,
          ...this.otherFormData,
        };
        for (let name in formData) {
          if (formData[name] !== null && formData[name] !== undefined) {
            if (name === 'collectionTimeDay') {
              customerInfo['customerInfo.incomeBalanceData.collectionDay'] = formData[name];
            } else if (name === 'reciveTimeDay') {
              customerInfo['customerInfo.incomeBalanceData.reciveDay'] = formData[name];
            } else {
              customerInfo['customerInfo.incomeBalanceData.' + name] = formData[name];
            }
          }
        }
        formData = customerInfo;
      }
      return formData;
    },
    setDetailData (data) {
      if (data.incomePaymentDaysInfo) {
        data.balanceType = `${data.incomePaymentDaysInfo.balanceType}`;
      }

      if (data.incomePaymentDaysInfo) {
        data.reciveTime = data.incomePaymentDaysInfo.reciveTime || '';
        data.reciveMonth = data.incomePaymentDaysInfo.reciveMonth || '';
        data.reciveTimeDay = data.incomePaymentDaysInfo.reciveDay || '';
        data.collectionTime = data.incomePaymentDaysInfo.collectionTime || '';
        data.collectionMonth = data.incomePaymentDaysInfo.collectionMonth || '';
        data.collectionTimeDay = data.incomePaymentDaysInfo.collectionTimeDay || '';
      }
    },
    init (data = {}) {
      this.setDetailData(data);
      const res = {
        balanceType: data.balanceType || '1',
      };
      this.$refs.baseForm.setVal('form', res);
      this.otherFormData = {
        reciveTime: data ? data.reciveTime : '', // 回单期限天数
        reciveMonth: data ? (data.reciveMonth || data.reciveTime) : '', // 回单期限第几个月
        reciveTimeDay: data ? (data.reciveTimeDay || data.reciveTimeDay) : '', // 回单期限第几号
        collectionTime: data ? data.collectionTime : '', // 收款期限天数
        collectionMonth: data ? (data.collectionMonth || data.collectionTime) : '', // 收款期限第几个月
        collectionTimeDay: data ? (data.collectionTimeDay || data.collectionTimeDay) : '', // 收款期限第几号
      };
      this.handleLabelTypeChange();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
